export const RECEIVES_ENTITIES = 'RECEIVES_ENTITIES'
export const RECEIVES_CITIES = 'RECEIVES_CITIES'
export const ACTIVATED_ENTITY = 'ACTIVATED_ENTITY'
export const SHOW_INTRODUCTION = 'SHOW_INTRODUCTION'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js